import React from 'react';

// #565: Zeichen und Wortmarke „KayCee Ticket“ wie in KayCee Time
// (templatetags kct.brand_mark/wordmark). Beide Darstellungen stehen im DOM,
// themes/kaycee.css zeigt je nach data-theme die passende: Modern mit Porträt
// und K/C in Hellblau, Klassisch mit weißer Silhouette, C-Kachel und „ai“.
// So wechselt die Darstellung ohne Neuladen und ohne neuen Render.
// `kompakt` (schmale Kopfzeile) lässt das Produktwort weg.
export default function Wortmarke({ kompakt = false }) {
  return (
    <span className="kc-lockup">
      <span className="kc-zeichen" aria-hidden="true">
        <img className="kc-zeichen__portrait" src="/kaycee/kaycee-portrait-avatar.webp" alt="" width="38" height="38" />
        <img className="kc-zeichen__silhouette" src="/kaycee/kaycee-silhouette-white.png" alt="" width="38" height="38" />
      </span>
      <span className="kc-wortmarke">
        <b>K</b>ay<b className="kc-wortmarke__kachel">C</b>ee
        <span className="kc-wortmarke__ai" aria-hidden="true">ai</span>
        {!kompakt && <> <span className="kc-wortmarke__produkt">Ticket</span></>}
      </span>
    </span>
  );
}
